import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from "next-intl";
import { BusinessType, RealEstate } from "@/types/real-estate";
import { Gender, ListingType } from "@/components/modules/listings/api/schema";
import { formatSmartAvailability } from "@/lib/time";
export function useRealEstateAttributes(detailData, realEstateType) {
  const $ = _c(28);
  const t = useTranslations("modules.realEstateDetail");
  const locale = useLocale();
  const roomData = detailData.roomData;
  const isDemand = detailData.listingType === ListingType.DEMAND;
  let t0;
  if ($[0] !== isDemand || $[1] !== roomData?.gender || $[2] !== t) {
    t0 = roomData?.gender === Gender.MALE ? t("maleGender") : roomData?.gender === Gender.FEMALE ? t("femaleGender") : isDemand ? "-" : t("anyGender");
    $[0] = isDemand;
    $[1] = roomData?.gender;
    $[2] = t;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const genderLabel = t0;
  const genderColor = roomData?.gender === Gender.MALE ? "text-blue-500" : roomData?.gender === Gender.FEMALE ? "text-rose-500" : "text-foreground-heading";
  let t1;
  if ($[4] !== roomData || $[5] !== t) {
    t1 = roomData?.maxPersons === 2 ? t("doubleRoom") : roomData?.maxPersons && roomData.maxPersons >= 3 ? t("dormitory") : t("singleRoom");
    $[4] = roomData;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const roomTypeLabel = t1;
  const isRoom = detailData.businessType === BusinessType.RoomRent;
  const showEnergyCert = !isRoom;
  const showArea = !isRoom;
  const showPricePerSqm = !isRoom && detailData.businessType !== BusinessType.Rent;
  const showType = !isRoom;
  const hasEnergyCert = !!detailData.energyCertificationType;
  const areaLabel = detailData.totalArea ? `${detailData.totalArea} m²` : "-";
  const typeLabel = realEstateType || "-";
  let t2;
  if ($[7] !== detailData.salePrice || $[8] !== detailData.totalArea) {
    t2 = Number(detailData.salePrice) > 0 && Number(detailData.totalArea) > 0 ? (Number(detailData.salePrice) / Number(detailData.totalArea)).toFixed(1) : null;
    $[7] = detailData.salePrice;
    $[8] = detailData.totalArea;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const pricePerSqm = t2;
  let t3;
  if ($[10] !== locale || $[11] !== roomData) {
    t3 = roomData?.availableFrom ? formatSmartAvailability(roomData.availableFrom, locale === "pt" ? "pt" : "enGB", true) : null;
    $[10] = locale;
    $[11] = roomData;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const availabilityLabel = t3;
  const depositLabel = roomData?.deposit ? `${roomData.deposit} €` : "-";
  let t4;
  if ($[13] !== areaLabel || $[14] !== availabilityLabel || $[15] !== depositLabel || $[16] !== genderColor || $[17] !== genderLabel || $[18] !== hasEnergyCert || $[19] !== pricePerSqm || $[20] !== roomData || $[21] !== roomTypeLabel || $[22] !== showArea || $[23] !== showEnergyCert || $[24] !== showPricePerSqm || $[25] !== showType || $[26] !== typeLabel) {
    t4 = {
      roomData,
      genderLabel,
      genderColor,
      roomTypeLabel,
      showEnergyCert,
      showArea,
      showPricePerSqm,
      showType,
      hasEnergyCert,
      areaLabel,
      typeLabel,
      pricePerSqm,
      availabilityLabel,
      depositLabel
    };
    $[13] = areaLabel;
    $[14] = availabilityLabel;
    $[15] = depositLabel;
    $[16] = genderColor;
    $[17] = genderLabel;
    $[18] = hasEnergyCert;
    $[19] = pricePerSqm;
    $[20] = roomData;
    $[21] = roomTypeLabel;
    $[22] = showArea;
    $[23] = showEnergyCert;
    $[24] = showPricePerSqm;
    $[25] = showType;
    $[26] = typeLabel;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  return t4;
}